import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";

const CustomerOrdersView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const [orderProgress, setOrderProgress] = useState('0.00%');

  let customer_id = localStorage.getItem("customer_id");

  let season_id = localStorage.getItem("season_id");
  useEffect(() => {
    axios
      .get(`/customerportal/orders/view/${id+'-'+customer_id+'-'+season_id+'-portal_user'}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.order);
          let order_detail = response.data.data.order;
          let order_progress = (order_detail.pallets_count / order_detail.total_number_of_pallets) *100;
          console.log(order_progress.toFixed(3));
          //setOrderProgress(order_progress.toFixed(3)+"%")

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper customer-portal-main ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Orders</h3>
                  <ul className="breadcrumb">
                     <li className="breadcrumb-item">
                      <Link to="/customerportal/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/orders">Orders</Link>
                    </li>
                    <li className="breadcrumb-item active">View Order</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Order Info</h4>
                   
                    <table className="table table-bordered">
                     
                    <tr>
                        <th className="p-3">PO Number</th>
                        <td className="p-3">{value.po_number}</td>
                      </tr>
                    
                       <tr>
                        <th className="p-3">Customer</th>
                        <td className="p-3">
                          {value.customer ? value.customer.company_name : ""}
                        </td>
                      </tr>
                      
                     
                      <tr>
                        <th className="p-3">Shipping Method</th>
                        <td className="p-3">
                          {value.ship_method ? value.ship_method.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Shipping Address</th>
                        <td className="p-3">
                          {value.ship_address
                            ? value.ship_address.name
                            : ""}
                        </td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Broker</th>
                        <td className="p-3">
                          {value.broker_detail
                            ? value.broker_detail.broker_name
                            : ""}
                        </td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Order Status</th>
                        <td className="p-3">
                          {value.status ? value.status.title : ""}
                        </td>
                      </tr>
                     
                    
                    </table>
                  
                             
                      <br />
                      <h5 className="card-title">Finalised Pallets: {(value.pallets_count && value.pallets_count)?value.pallets_count:0}</h5>
                      
                        <table className="table table-bordered text-center">
                          <tr>
                            <th className="p-3 ">Barcode Number</th>
                            <th className="p-3">Product</th>
                            {/* <th className="p-3">Shift</th> */}
                            <th className="p-3">Caliber </th>
                            <th className="p-3">Number of boxes </th>
                          </tr>
                            {value.final_productions && value.final_productions.map((item_pallet, indx) => (
                                  <tr   key={item_pallet.product_name || indx}>
                                    <td className="p-3">
                                      {item_pallet.barcode_number}
                                      </td>
                                      <td className="p-3">{item_pallet.product_name}</td>
                                      {/* <td className="p-3">{item_pallet.shift}</td> */}
                                    <td className="p-3">{item_pallet.calibre}</td>
                                    <td className="p-3">{item_pallet.number_of_boxes}</td>
                                  </tr>
                              ))}
                      </table>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerOrdersView;
